
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as gELD8GaWLJELKa4wN5FEV2E5_45LuIQLQTjyt_CRviOGpsMeta } from "/codebuild/output/src1181859560/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue?macro=true";
import { default as indexRz_O_26tsGhP_byqBp84BfpNNUbvd7lHQAQ61QyR60cMeta } from "/codebuild/output/src1181859560/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue?macro=true";
import { default as search9oLxHn5_45PXfsXngmeSqiUERBe4WJtVit3qpk_Rh2ZoYMeta } from "/codebuild/output/src1181859560/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue?macro=true";
import { default as indexILK9fCwN4QIFFaB1r43ckbo5TUOsxGSX8KrQTROi1jgMeta } from "/codebuild/output/src1181859560/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue?macro=true";
import { default as _91id_935tGBTsaizV1xcDv6XYXQpgiItO7kwGRUkYi29qcF6ZwMeta } from "/codebuild/output/src1181859560/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue?macro=true";
import { default as indexcJkmP9tAp2yMFOMeSCSIsjB3WXkLIMz_45j2iiWF0_45DlIMeta } from "/codebuild/output/src1181859560/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue?macro=true";
import { default as _91id_938XXBPBgr4Uj8hDJl8aicsl2tO4dvfYLO1QpSMfZXssQMeta } from "/codebuild/output/src1181859560/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue?macro=true";
import { default as indexs4FLwakPU62cLL63gduLBoYxq6Ot3XZv48t_4QXzPYYMeta } from "/codebuild/output/src1181859560/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue?macro=true";
import { default as _91id_93h_rYbjWyAsGf9W6WhjT5mFnULIXubHa_45Mrwx_qAwIkEMeta } from "/codebuild/output/src1181859560/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue?macro=true";
import { default as indexg8lTvrtRajotWpEogdGVFxbT4QW51VmkTafWuN4_45GbQMeta } from "/codebuild/output/src1181859560/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue?macro=true";
import { default as indexVHZ9aR2aTsCUDrc8VNWRMRNZCT3fyXPu3Jq9FmPv13AMeta } from "/codebuild/output/src1181859560/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue?macro=true";
export default [
  {
    name: "g",
    path: "/g",
    component: () => import("/codebuild/output/src1181859560/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/codebuild/output/src1181859560/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue")
  },
  {
    name: "search",
    path: "/search",
    component: () => import("/codebuild/output/src1181859560/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue")
  },
  {
    name: "v8",
    path: "/v8",
    component: () => import("/codebuild/output/src1181859560/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue")
  },
  {
    name: "video-id",
    path: "/video/:id()",
    component: () => import("/codebuild/output/src1181859560/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue")
  },
  {
    name: "terms",
    path: "/terms",
    meta: indexcJkmP9tAp2yMFOMeSCSIsjB3WXkLIMz_45j2iiWF0_45DlIMeta || {},
    component: () => import("/codebuild/output/src1181859560/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue")
  },
  {
    name: "article-id",
    path: "/article/:id()",
    component: () => import("/codebuild/output/src1181859560/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue")
  },
  {
    name: "contact",
    path: "/contact",
    meta: indexs4FLwakPU62cLL63gduLBoYxq6Ot3XZv48t_4QXzPYYMeta || {},
    component: () => import("/codebuild/output/src1181859560/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue")
  },
  {
    name: "v8-article-id",
    path: "/v8/article/:id()",
    component: () => import("/codebuild/output/src1181859560/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue")
  },
  {
    name: "privacy-policy",
    path: "/privacy-policy",
    meta: indexg8lTvrtRajotWpEogdGVFxbT4QW51VmkTafWuN4_45GbQMeta || {},
    component: () => import("/codebuild/output/src1181859560/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue")
  },
  {
    name: "privacy-policy-relationships",
    path: "/privacy-policy/relationships",
    meta: indexVHZ9aR2aTsCUDrc8VNWRMRNZCT3fyXPu3Jq9FmPv13AMeta || {},
    component: () => import("/codebuild/output/src1181859560/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue")
  }
]